<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />
<div class="container" fxLayout="row" fxLayoutGap="20" fxLayoutAlign="center">
    <div fxLayout="row" fxFlex="100">
        <div class="breadcrumb" fxLayoutAlign="start" fxFlex="70">
            <p>
              <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> /
              <span>Notification List</span> 
            </p>
          </div> 
          <div class="mat-button-div" fxLayoutAlign="end" fxFlex="30">
            <button class="mat-button-create" mat-raised-button [routerLink]="['/notification']">Create Notification</button>
          </div>  
    </div>
    <div fxLayout="row" class="table-notification-div" fxFlex="95" fxLayoutAlign="center">
      <table>
        <thead>
          <tr class="mat-card-title">
            <th class="serialno">S.No</th>
            <th class="pushtitle">Push Title</th>
            <th class="pushbody">Push Body</th>
            <th class="redirectlink">Redirect URL</th>
            <th class="language">Language</th>
            <th class="createdby">Created By <small>({{ timeZoneOffset }})</small></th>
            <th class="updatedby">Updated By <small>({{ timeZoneOffset }})</small></th>    
            <th class="status">Status</th>
            <th class="actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let notification of notifications; let i = index">
            <tr>
              <td>{{i + 1}}</td>
              <td>
                <div *ngIf="notification.push.en" class="content">{{notification.push.en.push_title}}</div>
                <div *ngIf="notification.push.fr" class="content">{{notification.push.fr.push_title}}</div>
              </td>
              <td class="body-content">
                <div *ngIf="notification.push.en" class="content">{{notification.push.en.push_body}}</div>
                <div *ngIf="notification.push.fr" class="content">{{notification.push.fr.push_body}}</div>
              </td>
              <td>
                <div *ngIf="notification.push.en" class="content">
                    <a [href]="notification.push.en.redirect_url" target="_blank" rel="noopener noreferrer">
                        {{notification.push.en.redirect_url}}
                    </a>
                </div>
                <div *ngIf="notification.push.fr" class="content">
                    <a [href]="notification.push.fr.redirect_url" target="_blank" rel="noopener noreferrer">
                        {{notification.push.fr.redirect_url}}
                    </a>
                </div>
            </td>            
              <td>
                <div *ngIf="notification.push.en" class="content">English</div>
                <div *ngIf="notification.push.fr" class="content">French</div>
              </td>
              <td>{{notification.created_by}} <br> {{notification.created_time | date : 'medium'}}</td>
              <td>{{notification.updated_by}} <br> {{notification.updated_time | date : 'medium'}}</td>
              <td>{{notification.state}}</td> 
              <td>
                <mat-menu class="mat-menu" #menu="matMenu">
                  <button mat-menu-item  class="mat-menu-item" *ngIf="notification.state !== 'PUBLISH'" (click)="test(notification)">Test</button>
                  <button mat-menu-item class="mat-menu-item" *ngIf="notification.state !== 'PUBLISH'" (click)="update(notification)">Update</button>
                  <button mat-menu-item class="mat-menu-item" *ngIf="notification.state !== 'PUBLISH'" (click)="release(notification.id)">Release</button>
                  <button mat-menu-item class="mat-menu-item" (click)="delete(notification.id)">Delete</button>
                </mat-menu>
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <i class="fas fa-ellipsis-v"></i>
                </button>
              </td>  
            </tr>
          </ng-container>
        </tbody>
      </table>
  </div> 
</div>